import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'reactstrap';
import { GrayScaleImage } from './GrayScaleImage';
export const TrialGraph = ({ trialGraphType, handleActivateTrial }) => {
    const { t } = useTranslation();
    return _jsxs("div", { className: 'trial-graph', children: [_jsx("div", { className: "more-in-pro", children: _jsx(Button, { color: "outline-secondary", size: "md", className: "btn-activate-trial", onClick: handleActivateTrial, children: t('settings.tryPro', { siteName: t('siteName') }) }) }), _jsx(GrayScaleImage, { trialGraphType: trialGraphType })] });
};
